export default __webpack_public_path__ + "static/image-06-480x298-62e07e8b758825f3c8bd3e845f9e7467.jpg";